<template lang="pug">
    div
        // code {{ $store.state.dashboard.queryFilter }}
        Row(:gutter="16")
            Col.selectorCol(flex="3" v-if="isWithGroupName")
                GroupNameSelector

            Col.selectorCol(flex="3" v-if="isWithServiceGroupName")
                ServiceGroupNameSelector

            Col.selectorCol(flex="3" v-if="isWithTags")
                TagSelector(:placeholder="$t('domainsetting.tags')")

            Col.selectorCol(flex="3" v-if="isWithAppProfileName")
                AppProfileNameSelector

        Row(:gutter="16")
            Col.selectorCol(flex="3" v-if="isWithServerName")
                ServerNameSelector

            Col.selectorCol(flex="3" v-if="isWithOrigin")
                OriginSelector

            Col.selectorCol(flex="3" v-if="isWithSlbName")
                SlbNameSelector

            Col.selectorCol(flex="3" v-if="isWithEdgeName")
                EdgeNameSelector

            Col.selectorCol(flex="3" v-if="isWithLatencyStatusName")
                LatencyStatusNameSelector

            Col.selectorCol(flex="3" v-if="isWithDateRange")
                DateRangeSelector(:customTimeRangeOptions="this.customTimeRangeOptions" :dateRangeLimit="this.dateRangeLimit")

            Col.selectorCol(span="2" v-if="isWithSearchBtn" )
                SearchChartBtn(searchBtnIcon="md-refresh")
</template>

<script>
import { getFormOptions } from "@/api/formoptions";
import GroupNameSelector from "@/components/FormItems/GroupNameSelector";
import ServiceGroupNameSelector from "@/components/FormItems/ServiceGroupNameSelector";
import AppProfileNameSelector from "@/components/FormItems/AppProfileNameSelector";
import ServerNameSelector from "@/components/FormItems/ServerNameSelector";
import TagSelector from "@/components/FormItems/TagSelector";
import OriginSelector from "@/components/FormItems/OriginSelector";
import SlbNameSelector from "@/components/FormItems/SlbNameSelector";
import EdgeNameSelector from "@/components/FormItems/EdgeNameSelector";
import LatencyStatusNameSelector from "@/components/FormItems/LatencyStatusNameSelector";
import DateRangeSelector from "@/components/FormItems/DateRangeSelector";
import SearchChartBtn from "@/components/SearchChartBtn";

export default {
    name: "DashboardQueryFilterV2",
    components: {
        GroupNameSelector,
        ServiceGroupNameSelector,
        AppProfileNameSelector,
        ServerNameSelector,
        TagSelector,
        OriginSelector,
        SlbNameSelector,
        EdgeNameSelector,
        LatencyStatusNameSelector,
        DateRangeSelector,
        SearchChartBtn,
    },
    data() {
        return {};
    },
    props: {
        isWithGroupName: {
            type: Boolean,
            default: false,
        },
        isWithServiceGroupName: {
            type: Boolean,
            default: true,
        },
        isWithAppProfileName: {
            type: Boolean,
            default: true,
        },
        isWithServerName: {
            type: Boolean,
            default: true,
        },
        isWithTags: {
            type: Boolean,
            default: true,
        },
        isWithOrigin: {
            type: Boolean,
            default: true,
        },
        isWithSlbName: {
            type: Boolean,
            default: false,
        },
        isWithEdgeName: {
            type: Boolean,
            default: false,
        },
        isWithLatencyStatusName: {
            type: Boolean,
            default: false,
        },
        isWithDateRange: {
            type: Boolean,
            default: true,
        },
        isWithSearchBtn: {
            type: Boolean,
            default: true,
        },
        customTimeRangeOptions: {
            type: Array,
        },
        dateRangeLimit: { type: Number, default: 90 },
    },
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {
        // 有人沒使用的話必須清空該欄位
        if (!this.isWithGroupName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "groupNames", value: [] });

        if (!this.isWithServiceGroupName)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serviceGroupNames", value: [] });

        if (!this.isWithAppProfileName)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "appProfileNames", value: [] });

        if (!this.isWithServerName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "serverNames", value: [] });

        if (!this.isWithOrigin) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "originHosts", value: [] });

        if (!this.isWithSlbName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "slbNames", value: [] });

        if (!this.isWithEdgeName) this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "edgeNames", value: [] });

        if (!this.isWithLatencyStatusName)
            this.$store.commit("SET_DASHBOARD_QUERY_FILTER", { key: "latencyStatusNames", value: [] });
    },
    methods: {},
    computed: {},
};
</script>
<style>
.selectorCol {
    margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardQueryFilterV2.vue